import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.less";

class Arrow extends React.Component {
  static position = {
    UP: "0deg",
    DOWN: "180deg",
    LEFT: "-90deg",
    RIGHT: "90deg"
  };
  render() {
    const { style, className, direction } = this.props;
    return (
      <svg
        viewBox="0 0 200 79"
        style={{
          transform: `rotate(${direction})`,
          ...style
        }}
        className={`${styles.arrow} ${className}`}
      >
        <path d="M0,72l7,7,94-67,93,67,6-7L101,1Z" />
      </svg>
    );
  }
}

const arrowPositionsKeys = Object.values(Arrow.position);

Arrow.defaultProps = {
  style: {},
  className: "",
  direction: Arrow.position.RIGHT
};

Arrow.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.oneOf(arrowPositionsKeys)
};

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/common/Arrow/Arrow.js